import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'bil-white-listing-dialog',
  templateUrl: './white-listing-dialog.component.html',
  styleUrls: ['./white-listing-dialog.component.sass']
})
export class WhiteListingDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<WhiteListingDialogComponent>) { }

  ngOnInit() {
  }

  onClose() {
    this.dialogRef.close();
  }

}
